"use client";
import React from "react";
import Head from "next/head";
import PropTypes from "prop-types";
import {
  Divider,
  Segment,
  Icon,
  Grid,
  GridRow,
  GridColumn,
  Form,
  Button,
  Message,
  TextArea,
  Loader,
} from "semantic-ui-react";
import Modal from "react-modal";
import Slidersingle from "react-rangeslider";
import { ItemData, Paginate, FormError } from "../../components";
import Link from "next/link";

import { get_converted_value } from "../../common/Utils";
import { sendNotification } from "../../modules/Graphql/notificationgraphql";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "30%",
    animation: "slideIn 0.7s ease-out",
  },
  overlay: {
    background: "rgba(0, 0, 0, 0.8)",
  },
};

class FeedbackForm extends React.Component {
  // static async getInitialProps({ query }) {
  //   return { query };
  // }
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      feedbackval: 4,
      feedbackslidererr: false,
      sitefeedback: "",
      improvefeedback: "",
      sitefeedback_err_status: false,
      sitefeedback_err_msg: "",
      improvefeedback_err_status: false,
      improvefeedback_err_msg: "",
      mailsuccess: false,
      mailerr: false,
      closing: false,
      isLoading: false,
    };
  }
  closeFeedbackmodal = () => {
    this.setState({ closing: true });
    // this.setState({
    //   open: false,
    //   feedbackval: 4,
    //   sitefeedback: "",
    //   improvefeedback: "",
    // });
    // localStorage.setItem("popupShown", "true");
    setTimeout(() => {
      this.setState({
        open: false,
        closing: false,
        feedbackval: 4,
        sitefeedback: "",
        improvefeedback: "",
      });
      localStorage.setItem("popupShown", "true");
    }, 300);
    //this.props.closeFeedbackModal();
  };

  openFeedbackmodal = () => {
    this.setState({ open: true });
    localStorage.setItem("popupShown", "true");
  };

  feedbackSliderchange = (feedbackval) => {
    if (feedbackval > 0) {
      this.setState({
        feedbackslidererr: false,
      });
    } else {
      this.setState({
        feedbackslidererr: true,
      });
    }
    this.setState({ feedbackval });
  };
  handlesitefeedbackChange = (e) => {
    this.setState({
      sitefeedback: e.target.value,
      sitefeedback_err_status: false,
    });
  };
  handleimprovefeedbackChange = (e) => {
    this.setState({
      improvefeedback: e.target.value,
      improvefeedback_err_status: false,
    });
  };
  addCustomerFeedback = () => {
    var flag = 1;
    if (this.state.sitefeedback === "") {
      flag = 0;
      this.setState({
        sitefeedback_err_status: true,
        sitefeedback_err_msg: "Please enter your feedback regarding site.",
      });
    } else {
      this.setState({ sitefeedback_err_status: false });
    }
    if (this.state.improvefeedback === "") {
      flag = 0;
      this.setState({
        improvefeedback_err_status: true,
        improvefeedback_err_msg:
          "Please enter your feedback regarding improvment",
      });
    } else {
      this.setState({ improvefeedback_err_status: false });
    }
    if (this.state.sitefeedback !== "" && this.state.improvefeedback !== "") {
      this.setState({ isLoading: true });
      //add logic for submit the data
      this.sendFeedbackmail(
        "Feedback",
        this.state.feedbackval,
        this.state.sitefeedback,
        this.state.improvefeedback,
      );
    }
  };

  sendFeedbackmail = (subject, feedbackval, sitefeedback, improvefeedback) => {
    const noti_data = {
      subject: subject,
      message: feedbackval,
      userId: sitefeedback,
      neighborhoodId: improvefeedback,
      questionid: "feedbackemail",
    };

    sendNotification(noti_data)
      .then((result) => {
        this.setState({ mailsuccess: true, isLoading: false });
        setTimeout(() => {
          this.closeFeedbackmodal();
        }, 3000);
      })
      .catch((error) => {
        this.setState({ mailerr: true, isLoading: false });
      });
  };

  componentDidMount() {
    // Set app element for react-modal accessibility
    if (typeof window !== "undefined") {
      Modal.setAppElement(document.body);
    }

    if (localStorage.getItem("popupShown") !== "true") {
      let startTime = localStorage.getItem("startTime");
      if (!startTime) {
        startTime = Date.now();
        localStorage.setItem("startTime", startTime);
      }

      const currentTime = Date.now();
      const elapsed = currentTime - parseInt(startTime, 10);
      const remainingTime = Math.max(600000 - elapsed, 0);

      if (remainingTime <= 0) {
        this.openFeedbackmodal();
      } else {
        this.timer = setTimeout(() => {
          this.openFeedbackmodal();
        }, remainingTime);
      }
    }
  }

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  render() {
    const { feedbackval, sitefeedback, improvefeedback, closing } = this.state;
    const formatfeedback = (feedbackval) => feedbackval;
    const horizontalLabels = {
      0: "0",
      0.5: "|",
      1: "1",
      1.5: "|",
      2: "2",
      2.5: "|",
      3: "3",
      3.5: "|",
      4: "4",
      4.5: "|",
      5: "5",
    };

    // if (this.props.isFeedbackModalOpen !== this.state.open) {
    //   this.setState({ open: this.props.isFeedbackModalOpen });
    // }
    return (
      <>
        <Head>
          <link
            rel="stylesheet"
            href="https://unpkg.com/react-rangeslider/umd/rangeslider.min.css"
          />
        </Head>
        <div className="button-container">
          <Button
            className="feedback_button ui medium"
            onClick={this.openFeedbackmodal}
          >
            Feedback?
          </Button>
          <div className="arrow-indicator"></div>
        </div>
        <Modal
          isOpen={this.state.open}
          onRequestClose={this.closeFeedbackmodal}
          style={{
            content: {
              ...customStyles.content,
              animation: closing
                ? "slideOut 0.5s ease-out"
                : "slideIn 0.7s ease-out",
            },
            overlay: customStyles.overlay,
          }}
          // className={`modal ${closing ? "closing" : "opening"}`}
        >
          <div
            className="close_icon_select close_personal close_perosnal_dnh"
            onClick={this.closeFeedbackmodal}
          >
            <a className="boxclose" id="boxclose"></a>
          </div>
          <Form onSubmit={this.addCustomerFeedback}>
            <Form.Field>
              <p className="feedback_title">Your Feedback Helps Us Improve!</p>
              <Grid>
                <GridRow className="feedback-align-center">
                  <Grid.Column
                    mobile={16}
                    tablet={8}
                    computer={8}
                    className="feedback-que"
                  >
                    How are you enjoying Houseberry?
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={8} computer={8}>
                    <div className="slider-text-top">
                      <p>Not Enjoyable</p>
                      <p>Love it!</p>
                    </div>
                    <div className="slider custom-labels">
                      <Slidersingle
                        min={0}
                        max={5}
                        value={feedbackval}
                        labels={horizontalLabels}
                        format={formatfeedback}
                        onChange={this.feedbackSliderchange}
                        step={0.5}
                      />
                      <div className="value">{/*formatprec(horizontal)*/}</div>
                    </div>
                  </Grid.Column>
                </GridRow>
                <GridRow className="site-question">
                  <Grid.Column mobile={16} tablet={16} computer={16}>
                    <p className="feedback-que">
                      What do you enjoy most about the site?
                    </p>
                    <TextArea
                      rows={2}
                      // placeholder="Please enter your valuable feedback"
                      value={sitefeedback}
                      onChange={this.handlesitefeedbackChange}
                    />
                    <FormError
                      err_status={this.state.sitefeedback_err_status}
                      err_msg={this.state.sitefeedback_err_msg}
                    />
                  </Grid.Column>
                </GridRow>
                <GridRow className="site-improvment">
                  <Grid.Column mobile={16} tablet={16} computer={16}>
                    <p className="feedback-que">
                      What needs improvement or what should we add next?
                    </p>
                    <TextArea
                      rows={2}
                      // placeholder="Please enter your valuable feedback"
                      value={improvefeedback}
                      onChange={this.handleimprovefeedbackChange}
                    />
                    <FormError
                      err_status={this.state.improvefeedback_err_status}
                      err_msg={this.state.improvefeedback_err_msg}
                    />
                  </Grid.Column>
                </GridRow>
                <GridRow>
                  <Grid.Column mobile={16} tablet={16} computer={16}>
                    <div className="feebackformsubmit">
                      <Button
                        type="submit"
                        primary
                        disabled={this.state.isLoading}
                      >
                        {this.state.isLoading && (
                          <Loader active inline size="tiny" />
                        )}{" "}
                        Submit
                      </Button>
                      <p
                        style={{
                          color: this.state.mailsuccess
                            ? "green"
                            : this.state.mailerr && "#c02e26",
                        }}
                      >
                        {this.state.mailsuccess &&
                          "Thank you for your valuable feedback"}
                        {this.state.mailerr &&
                          "Something went wrong!! Please try again later"}
                      </p>
                      {/* <p style={{ color: "#c02e26" }}>
                        {this.state.mailerr &&
                          "Something went wrong!! Please try again later"}
                      </p> */}
                    </div>
                  </Grid.Column>
                </GridRow>
              </Grid>
            </Form.Field>
          </Form>
        </Modal>
      </>
    );
  }
}

export default FeedbackForm;

export async function getStaticProps() {
  return {
    props: {
      query: {},
    },
  };
}
